import { connectedStore } from '../../store';
import getReadOnlyStatus from '../selectors/read-only';

const isReadOnlyModeEnabled = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getReadOnlyStatus(state);
};

export default isReadOnlyModeEnabled;
